import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=b5ef00c2&scoped=true&"
import script from "./MessageIndex.vue?vue&type=script&lang=js&"
export * from "./MessageIndex.vue?vue&type=script&lang=js&"
import style0 from "./MessageIndex.vue?vue&type=style&index=0&id=b5ef00c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ef00c2",
  null
  
)

export default component.exports